import { Locales } from 'Core/constants/locale'

import { localeEn } from './locales/en'
import { localeEs } from './locales/es'
import { localeFr } from './locales/fr'

export const RESOURCES = {
	[Locales.en]: localeEn,
	[Locales.es]: localeEs,
	[Locales.fr]: localeFr
}
